import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import LogoutConfirmation from "./logoutConfirmation/LogoutConfirmation";

const AccountSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showLogout, setShowLogout] = useState(false);

  const menuItems = [
    { path: "/my-account", icon: "ph-user", label: "My Account" },
    { path: "/my-orders", icon: "ph-package", label: "My Orders" },
    { path: "/address-book", icon: "ph-map-pin", label: "Address Book" },
  ];

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/");
  };

  return (
    <>
      {/* Mobile horizontal nav */}
      <div className="d-lg-none mb-16">
        <div
          className="d-flex gap-8 overflow-x-auto pb-4"
          style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        >
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className="d-inline-flex align-items-center gap-6 px-14 py-8 rounded-pill text-decoration-none fw-semibold flex-shrink-0 transition"
                style={{
                  background: isActive ? "#1a6b30" : "#fff",
                  color: isActive ? "#fff" : "#555",
                  border: isActive ? "1px solid #1a6b30" : "1px solid #e8f5e9",
                  boxShadow: isActive
                    ? "0 4px 10px rgba(26, 107, 48, 0.25)"
                    : "0 1px 4px rgba(0, 0, 0, 0.05)",
                  fontSize: "12.5px",
                  whiteSpace: "nowrap",
                }}
              >
                <i className={`ph ${item.icon}`} style={{ fontSize: "15px" }} />
                {item.label}
              </Link>
            );
          })}

          <button
            onClick={() => setShowLogout(true)}
            className="d-inline-flex align-items-center gap-6 px-14 py-8 rounded-pill fw-semibold flex-shrink-0 border-0 bg-white transition"
            style={{
              color: "#e53935",
              border: "1px solid #f5c6cb",
              boxShadow: "0 1px 4px rgba(0, 0, 0, 0.05)",
              fontSize: "12.5px",
              whiteSpace: "nowrap",
            }}
          >
            <i className="ph ph-sign-out" style={{ fontSize: "15px" }} />
            Logout
          </button>
        </div>
      </div>

      {/* Desktop sidebar */}
      <div
        className="d-none d-lg-block"
        style={{ position: "sticky", top: "24px" }}
      >
        <div
          className="bg-white rounded-16 overflow-hidden"
          style={{
            boxShadow: "0 4px 24px rgba(26, 107, 48, 0.08)",
            border: "1px solid #e8f5e9",
          }}
        >
          <div
            className="px-24 py-20 text-center"
            style={{
              background: "linear-gradient(135deg, #1a6b30 0%, #228b34 50%, #2ea44f 100%)",
            }}
          >
            <div
              className="d-inline-flex align-items-center justify-content-center rounded-circle mb-12"
              style={{
                width: "56px",
                height: "56px",
                background: "rgba(255,255,255,0.2)",
                backdropFilter: "blur(8px)",
                border: "2px solid rgba(255,255,255,0.3)",
              }}
            >
              <i className="ph ph-user text-white" style={{ fontSize: "28px" }} />
            </div>
            <h6 className="text-white fw-bold mb-0" style={{ fontSize: "15px" }}>
              My Account
            </h6>
            <p className="text-white mb-0 mt-4" style={{ fontSize: "11px", opacity: 0.85 }}>
              Manage your profile & orders
            </p>
          </div>

          <div className="p-12">
            <div className="d-flex flex-column gap-2">
              {menuItems.map((item) => {
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className="d-flex align-items-center gap-12 px-16 py-12 rounded-10 text-decoration-none transition"
                    style={{
                      background: isActive
                        ? "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)"
                        : "transparent",
                      color: isActive ? "#1a6b30" : "#555",
                      fontWeight: isActive ? "600" : "500",
                      border: isActive ? "1px solid #a5d6a7" : "1px solid transparent",
                      boxShadow: isActive ? "0 2px 8px rgba(26, 107, 48, 0.1)" : "none",
                    }}
                    onMouseEnter={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.background = "#f3faf2";
                        e.currentTarget.style.color = "#1a6b30";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.background = "transparent";
                        e.currentTarget.style.color = "#555";
                      }
                    }}
                  >
                    <i
                      className={`ph ${item.icon}`}
                      style={{
                        fontSize: "20px",
                        color: isActive ? "#1a6b30" : "#888",
                      }}
                    />
                    <span>{item.label}</span>
                    {isActive && (
                      <i
                        className="ph ph-caret-right ms-auto"
                        style={{ fontSize: "14px", color: "#1a6b30" }}
                      />
                    )}
                  </Link>
                );
              })}

              <div
                className="mt-4"
                style={{
                  borderTop: "1px solid #e8f5e9",
                  paddingTop: "8px",
                }}
              >
                <button
                  onClick={() => setShowLogout(true)}
                  className="d-flex align-items-center gap-12 px-16 py-12 rounded-10 border-0 bg-transparent text-start transition w-100"
                  style={{
                    color: "#e53935",
                    fontWeight: "500",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#ffebee";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "transparent";
                  }}
                >
                  <i className="ph ph-sign-out" style={{ fontSize: "20px" }} />
                  <span>Logout</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LogoutConfirmation
        isOpen={showLogout}
        onClose={() => setShowLogout(false)}
        onConfirm={handleLogout}
      />
    </>
  );
};

export default AccountSidebar;
